import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick", "disabledTitle", "use", "isTextTitle"];
import PropTypes from 'prop-types';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import Small from 'UIComponents/elements/Small';
import UIButton from 'UIComponents/button/UIButton';
import SettingsRowLayout from './SettingsRowLayout';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * SettingsRowButton variation of SettingsRow handles clickable titles for settings & actions.
 */
const SettingsRowButton = ({
  className,
  description,
  disabled,
  disabledTooltipTitle,
  illustrationName,
  onClick,
  title,
  titleButtonProps = {}
}) => {
  const {
      onClick: onTitleClick = onClick,
      disabledTitle = disabled,
      isTextTitle
    } = titleButtonProps,
    buttonProps = _objectWithoutPropertiesLoose(titleButtonProps, _excluded);
  const renderedTitle = isTextTitle ? /*#__PURE__*/_jsx("strong", {
    children: title
  }) : /*#__PURE__*/_jsx(UITooltip, {
    title: disabledTooltipTitle,
    disabled: !disabledTitle || !disabledTooltipTitle,
    children: /*#__PURE__*/_jsx(UIButton, Object.assign({
      use: "link",
      disabled: disabledTitle,
      onClick: onTitleClick
    }, buttonProps, {
      children: title
    }))
  });
  const renderedDescription = description && /*#__PURE__*/_jsx(Small, {
    className: "display-block",
    use: "help",
    children: description
  });
  return /*#__PURE__*/_jsx(SettingsRowLayout, {
    className: className,
    illustrationName: illustrationName,
    title: renderedTitle,
    description: renderedDescription
  });
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
SettingsRowButton.defaultProps = {
  titleButtonProps: {}
};
SettingsRowButton.propTypes = {
  className: PropTypes.string,
  /**
   * Description for this setting or action.
   */
  description: PropTypes.node,
  /**
   * Content in disabled tooltip.
   */
  disabledTooltipTitle: PropTypes.node,
  /**
   * If this setting or action is turned off.
   */
  disabled: PropTypes.bool,
  /**
   * SettingsRowLogo or SettingsRowIllustration node for visuals on the row.
   */
  illustration: PropTypes.node,
  /**
   * In-progress Deprecation: Illustration or logo name to render.
   */
  illustrationName: PropTypes.string,
  /**
   * Handler for title click interaction.
   */
  onClick: PropTypes.func,
  /**
   * Text for the setting title button/action.
   */
  title: PropTypes.node.isRequired,
  /**
   * UIButton passthrough props for title button/action. Omits `use` property from passthrough.
   */
  titleButtonProps: PropTypes.object
};
export default SettingsRowButton;